import { render, staticRenderFns } from "./IncomeDisbursement.vue?vue&type=template&id=8bbe8e8e&scoped=true"
import script from "./IncomeDisbursement.vue?vue&type=script&lang=js"
export * from "./IncomeDisbursement.vue?vue&type=script&lang=js"
import style0 from "./IncomeDisbursement.vue?vue&type=style&index=0&id=8bbe8e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbe8e8e",
  null
  
)

export default component.exports